<div class="card h-100" data-testid="course-card">
  <div class="card-body d-flex">
    <div class="d-flex flex-column w-100 h-100">
      <!-- Image -->
      <div class="col-sm-12 mb-0 cursor-pointer">
        <img [src]="
            data.image_url
              ? fileUrl + data.image_url
              : './assets/media/svg/files/blank-image.svg'
          " class="course-thumb rounded-nested bg-light min-h-200px" [attr.alt]="data.name" />
      </div>
      <!-------->
      <div class="col-sm-12 d-flex flex-column justify-content-between flex-grow-1 pt-8">
        <div class="mb-4">
          <div class="mb-6">
            <p
              class="text-gray-800 text-hover-primary min-h-40px fs-2 fw-bold lh-1 mb-2 cursor-pointer text-overflow-line-2">
              {{ data.name }}
            </p>
            @if (data.has_trial_videos) {
            <span class="badge badge-light-success mb-2" data-testid="trial-badge">
              {{ "APP.TRIAL_BADGE" | translate }}
            </span>
            }
            <!-- Rating on the card, not only on the detail page. It is the one
                 thing on a catalogue tile that comes from other students rather
                 than from the seller, and the row of cards had no warm colour
                 in it at all. -->
            @if (data.rating) {
            <div class="d-flex align-items-center gap-2 mb-2">
              <app-rating-star [rating]="data.rating" iconSize="fs-7"></app-rating-star>
              <span class="fs-7 fw-semibold text-gray-700">{{ ratingLabel() }}</span>
              @if (data.total_review) {
              <span class="fs-8 text-gray-500">({{ data.total_review }})</span>
              }
            </div>
            }
            <p class="text-gray-600 text-overflow-line-3 fs-5 mb-0">
              {{ data.description }}
            </p>
          </div>
        </div>

        <div #button_group class="col-12 border-top pt-6">
          <div class="d-flex justify-content-between align-items-center flex-wrap d-grid gap-2">
            <div class="d-flex align-items-center gap-2">
              <app-keenicon name="note" class="fs-2"></app-keenicon>
              <span class="text-gray-500 d-block fs-6">{{ data.total_chapter || 0 }}
                {{ "APP.LESSON" | translate }}</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <app-keenicon name="time" class="fs-2"></app-keenicon>
              <span class="text-gray-500 d-block fs-6">{{
                data.duration_video | durationVideo
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>